export default "__VITE_ASSET__u3U_Mpw0__"